import { AppShell, Button } from '@dj/ui';
import { useNavigate } from 'react-router-dom';

/**
 * Shown after every request for a claim link, whatever the outcome (Tess
 * re-scan 3, R11): the page must never reveal whether the details matched.
 */
export function CheckEmailPage() {
  const navigate = useNavigate();
  return (
    <AppShell title="Check your email">
      <div className="bg-white rounded-lg shadow p-6 sm:p-8 max-w-lg mx-auto">
        <h1 className="text-2xl font-semibold text-slate-900 mb-3">Check your email</h1>
        <p className="text-slate-700 mb-3">
          If your details are on your provider's list, we've emailed you a link to finish
          setting up. It goes to the email address your provider has for you.
        </p>
        <p className="text-slate-700 mb-6">The link works once, for 30 minutes.</p>
        <div className="bg-slate-50 border border-slate-200 rounded p-4 text-sm text-slate-700 mb-6">
          <p className="font-semibold mb-1">No email after a few minutes?</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Check your spam or junk folder.</li>
            <li>Check your name and date of birth are exactly as your provider has them.</li>
            <li>Ask your provider which email address they have for you.</li>
          </ul>
        </div>
        <Button variant="secondary" onClick={() => navigate('/identity')}>Try again</Button>
      </div>
    </AppShell>
  );
}
